(ns ycweb.app.website.dlp.widgets.infotext
  (:require
   [rum.core :as rum]
   [ycweb.components.headings :as headings]
   [ycweb.util.core :as u]))

(rum/defc info-text [{:keys [properties]}]
  (let [{:info-text/keys
         [on-page-link-id title title-size title-center copy copy-center]} properties]
    (when copy
      [:div.yc-section
       {:id (when (u/presence on-page-link-id) on-page-link-id)}
       [:div.u-block-center.u-max-width-720
        (when title
          (headings/heading title {:type :h3 :size title-size :center (when title-center true)}))
        (when (not (empty? copy))
          [:div.yc-simpletext
           {:class (when copy-center "u-text-center")}
           [:span {:dangerouslySetInnerHTML {:__html copy}}]])]])))
